import Styles from './HeroPagination.module.css'

export interface HeroPaginationProps {
  currentChapterIndex: number
  items: Array<{
    label: string
    duration?: number
  }>
  onChange: (index: number) => void
  a11y: {
    playToggle: string
  }
}

export const defaultProps: Partial<HeroPaginationProps> = {}

export const HeroPagination = (props: HeroPaginationProps) => {
  const initializedProps: HeroPaginationProps = {...defaultProps, ...props}
  // eslint-disable-next-line no-empty-pattern
  const {} = initializedProps

  return <div className={Styles['HeroPagination']}>HeroPagination</div>
}
